export const env = {
  ENV: (import.meta.env.VITE_ENV as 'dev' | 'production' | undefined) ?? 'dev',
  API_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:8787',
  CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined,
  /** Playwright 전용 (로컬). 있으면 Clerk 없이 이 값을 Bearer 로 쓴다 — API 는 ENVIRONMENT=local 에서만 인정 */
  E2E_TOKEN: (import.meta.env.VITE_E2E_TOKEN as string | undefined) || undefined,
} as const
